import React, { useContext, useEffect, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { Outlet, useLocation } from 'react-router'
import Navigation from '@App/navigation'
import { CLEAR_WORK_DRAFT } from '@Const/work-registration-forms'
import WorkRegistrationWizardRoad from '@Components/WorkRegistrationWizardRoad'
import FormBottomNavBar from '@Components/Navigations/CreateWorkBottomNavs/FormBottomNavBar'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'

const CreateWorkByFormLayout = () => {
    const { rightsholderStore, workStore } = useContext(StoresContext)
    const location = useLocation()
    const [currentStep, setCurrentStep] = useState<number>(0)
    const [currentStepType, setCurrentStepType] = useState<string>()
    const [backLink, setBackLink] = useState<string>()
    const [nextLink, setNextLink] = useState<string>()

    const setLinksToBar = (stepNumber: number) => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId
        switch (stepNumber) {
            case 0:
                setBackLink(Navigation.rightholder.createWork.root(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.submission(currentRightsholderId))
                setCurrentStepType('Create Work Form')
                break
            case 1:
                setBackLink(Navigation.rightholder.createWork.form.root(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.root(currentRightsholderId)) // Done work details
                setCurrentStepType('Work Details')
                break
            case 2:
                setBackLink(Navigation.rightholder.createWork.form.root(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.writersSharesRole(currentRightsholderId)) // Next
                setCurrentStepType('Writers - Add Writers')
                break
            case 3:
                setBackLink(Navigation.rightholder.createWork.form.writers(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.root(currentRightsholderId)) // Done writers
                setCurrentStepType('Writers - Add Roles')
                break
            case 4:
                setBackLink(Navigation.rightholder.createWork.form.root(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.publishersShares(currentRightsholderId)) // Next
                setCurrentStepType('Publishers - Add Publishers')
                break
            case 5:
                setBackLink(Navigation.rightholder.createWork.form.publishers(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.publishersWriters(currentRightsholderId)) // Next
                setCurrentStepType('Publishers - Add Shares')
                break
            case 6:
                setBackLink(Navigation.rightholder.createWork.form.publishersShares(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.root(currentRightsholderId)) // Done publishers
                setCurrentStepType('Publishers - Link Writers & Publishers')
                break
            case 7:
                setBackLink(Navigation.rightholder.createWork.form.root(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.form.root(currentRightsholderId)) // Done recordings
                setCurrentStepType('Recordings')
                break
            case 8:
                setBackLink(Navigation.rightholder.createWork.root(currentRightsholderId))
                setNextLink(Navigation.rightholder.createWork.root(currentRightsholderId))
                setCurrentStepType('Submission')
                break
            default:
                break
        }
    }

    const getCurrentStep = (): number => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId
        switch (location.pathname) {
            case Navigation.rightholder.createWork.form.root(currentRightsholderId):
                return 0
            case Navigation.rightholder.createWork.form.workDetails(currentRightsholderId):
                return 1
            case Navigation.rightholder.createWork.form.writers(currentRightsholderId):
                return 2
            case Navigation.rightholder.createWork.form.writersSharesRole(currentRightsholderId):
                return 3
            case Navigation.rightholder.createWork.form.publishers(currentRightsholderId):
                return 4
            case Navigation.rightholder.createWork.form.publishersShares(currentRightsholderId):
                return 5
            case Navigation.rightholder.createWork.form.publishersWriters(currentRightsholderId):
                return 6
            case Navigation.rightholder.createWork.form.recordings(currentRightsholderId):
                return 7
            case Navigation.rightholder.createWork.form.submission(currentRightsholderId):
                return 8
            default:
                return 0
        }
    }

    const initWorkDraft = () => workStore.setWorkDraftToLocal(CLEAR_WORK_DRAFT)

    useEffect(() => {
        analyticsSendPage('rightsholder_registration_new_work_form')
        initWorkDraft()
    }, [])

    useEffect(() => {
        const stepNumber = getCurrentStep()
        setCurrentStep(stepNumber)
        setLinksToBar(stepNumber)
    }, [location])

    const workDraftFromLocal = workStore.workDraftLocal

    if (!workDraftFromLocal) {
        return null
    }

    return (
        <>
            <title>Create work by form</title>
            <div className="create-work-scene">
                <div className="global-container steps-wrapper">
                    {currentStep !== 0 && currentStep !== 8 ? (
                        <div className="head-create-work-wizard">
                            <h5 title={workDraftFromLocal.title}>{workDraftFromLocal.title}</h5>
                            <h2>{currentStepType}</h2>
                            <WorkRegistrationWizardRoad currentStep={currentStep} onlyOneStep />
                        </div>
                    ) : null}
                    <Outlet />
                    <FormBottomNavBar
                        nextLink={nextLink}
                        backLink={backLink}
                        hideBackLink={!!backLink}
                        isFormStep={currentStep === 0}
                        isSubmittedStep={currentStep === 8}
                        isFinishEntityStep={
                            nextLink ===
                            Navigation.rightholder.createWork.form.root(rightsholderStore.currentRightsholderId)
                        }
                    />
                </div>
            </div>
        </>
    )
}

export default CreateWorkByFormLayout
